import { ReactNode, useCallback, useEffect, useState } from 'react';
import { LineFromApiType, LineType } from '../../types';
import { useAppContext } from '../../../../../contexts/auth';
import useApiCall from '../../../../../hooks/useApiCall';
import LinesService from '../../../../../services/affreightment/LinesService';
import { toast } from 'react-toastify';

export default function useLoadLines() {
  const [lines, setLines] = useState<LineType[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [apiFetched, setApiFetched] = useState(true);

  const { userData, selectedCompany } = useAppContext();
  const { apiCall } = useApiCall();

  const companyCode = selectedCompany.value;
  const { userCode, userProfile } = userData;

  const directionsTagLiterals: { [key: number]: ReactNode} = {
    0: '',
    1: <small>Ida</small>,
    2: <small className="orange">Volta</small>,
  };

  const loadLines = useCallback(async () => {
    await apiCall({
      apiToCall: LinesService.listLines,
      queryParams: { codEmpresa: companyCode, codUsu: userCode, perfilUsu: userProfile },
      onStartLoad: () => setIsLoading(true),
      onEndLoad: () => setIsLoading(false),
      actionAfterResponse: (response) => {
        if (!response.codigo) {
          toast.error(`Não foi possível recuperar as linhas (${response.msg})`);
          setApiFetched(false);
          return;
        }
        const linesList: LineFromApiType[] = response.linhasFretado;
        const mappedLines = linesList?.map((line) => ({
          lineId: line.codLinhaSis,
          lineCode: line.codLinhaF,
          direction: line.sentido,
          directionDescription: line.sentidoDescr,
          value: line.valorMes,
          capacity: line.capacidade,
          lineSign: line.letreiro,
          operatorCode: line.codOperadora,
          workplaceDescription: line.descrLocTrab,
          routeId: line.routeID,
          balancePoint: line.pontoEquilib,
          balancePointLimit: line.pontoEquilibLim,
          departureTime: line.horaSaida,
          arrivalTime: line.horaChegada,
          startBoardingTime: line.horaInicioEmb,
          workingDaysMonth: line.diasRoda,
          hasKmlFile: line.arqKml === 'S' ? true : false,
        }));
        setApiFetched(true);
        setLines(mappedLines);
      },
      catchAction: () => setApiFetched(false),
      catchMessage: 'Não foi possível recuperar as linhas',
    });
  }, [apiCall, companyCode, userCode, userProfile]);

  useEffect(() => {
    if (companyCode) {
      loadLines();
    }
  }, [companyCode, loadLines]);

  function handleTryAgain() {
    loadLines();
  }

  return {
    lines,
    isLoading,
    apiFetched,
    directionsTagLiterals,
    handleTryAgain,
    userProfile,
    companyCode,
    loadLines,
  };
}
